// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_9LS","cls2":"CiterightInline-cls2_vqf CiterightInline-cls1_9LS"};